<template>
	<div class="home">
		<div class="main-panel">
			<div class="content">


				<div class="panel-header bg-primary-gradient">
					<div class="page-inner py-5">
						<div class="d-flex align-items-left align-items-md-center flex-column flex-md-row">
							<div>
								<h2 class="text-white pb-2 fw-bold">Ketersediaan Pangan</h2>
							</div>
							<div class="ml-md-auto py-2 py-md-0">
								<div class="form-group">
									<div class="input-group">
										<select @change="getTahun()" class="form-control" v-model="form.thn">
                                            <option v-for="data in list_thn" :key="data.id" :value="data.id">{{data.tahun}}</option>
                                        </select>
										<div class="input-group-append">
											<button @click="print" class="btn btn-primary" type="button" title="Cetak Data"><i class="fas fa-plus"></i></button>

										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

<!-- <h1>TES1</h1>


<pdf src="https://crossorigin.me/http://36.89.95.163:5100/uploads/peraturan/1564543467109.pdf"></pdf>
<h1>TES2</h1> -->

				<div class="page-inner mt--5" >
					<!-- <h1>asdfad</h1> -->
					<div class="table-responsive" style="background:white; overflow-x:auto;">
                        <div id="printMe">
                            <table class="table-kiken table table-head-bg-info" width="100%" >
                                <thead>
                                    <tr class="bg-primary">
                                        <th scope="col" rowspan="2" style="width: 5%">No</th>
                                        <th scope="col" rowspan="2" style="width: 15%">Kecamatan</th>
                                        <th scope="col" rowspan="2" style="width: 15%">Komoditas</th>
                                        <th scope="col" rowspan="2" style="width: 10%"  class="text-center">Januari <br> 2019</th>
                                        <th scope="col" colspan="5"  class="text-center">Tahun Berjalan</th>

                                        <th scope="col" rowspan="2" style="width: 10%"  class="text-center">Rata-rata<br>Jan 5 Th</th>
                                        <th scope="col" colspan="2"  class="text-center">Hasil</th>
                                        <th scope="col" colspan="2"  class="text-center">Bobot</th>
                                    </tr>
                                    <tr class="bg-primary">

                                        <th scope="col" style="width: 5%">2014</th>
                                        <th scope="col" style="width: 5%">2015</th>
                                        <th scope="col" style="width: 5%">2016</th>
                                        <th scope="col" style="width: 5%">2017</th>
                                        <th scope="col" style="width: 5%">2018</th>
                                        <th scope="col" style="width: 5%">Value</th>
                                        <th scope="col" style="width: 5%">Bobot</th>
                                        <th scope="col" style="width: 5%">Value</th>
                                        <th scope="col" style="width: 5%">Bobot</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.kecamatan_id">
                                        <td class="text-center">{{index+1}}</td>
                                        <td >{{data.nama_kecamatan}}</td>
                                        <td >{{data.kode_pangan}}</td>
                                        <td >{{data.luas_thn6_bln_1}}</td>
                                        <td >{{data.luas_thn1}}</td>
                                        <td >{{data.luas_thn2}}</td>
                                        <td >{{data.luas_thn3}}</td>
                                        <td >{{data.luas_thn4}}</td>
                                        <td >{{data.luas_thn5}}</td>
                                        <td >{{data.rata_rata}}</td>
                                        <td >{{data.hasil_value}}</td>
                                        <td >{{data.hasil_bobot}}</td>
                                        <td >{{data.bobot_value}}</td>
                                        <td >{{data.bobot_status}}</td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>



					</div>

				</div>




                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_add_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-info">
                                    <h5 class="modal-title">TAMBAH DATA</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <form >
                                    <div class="modal-body">
                                        <div id="editor"></div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn bgcol-info btn-xs">SIMPAN</button>
                                        <button type="button" class="btn bgcol-danger btn-xs" data-dismiss="modal">BATAL</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-warning">
                                    <h5 class="modal-title">EDIT DATA</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <img class="img-fluid" src="http://36.89.95.163:5100/uploads/1562777027745.jpg" alt="">
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn bgcol-warning btn-xs">Edit</button>
                                    <button type="button" class="btn bgcol-danger btn-xs" data-dismiss="modal">Batal</button>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_lihat_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-header">
                                    <h5 class="modal-title">GAMBAR DETIL</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <img class="img-fluid" src="http://36.89.95.163:5100/uploads/1562777027745.jpg" alt="">
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn bgcol-danger btn-xs" data-dismiss="modal">Keluar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->




			</div>


		<!-- Footer -->
			<foother></foother>
			<!-- End Footer -->


		</div>
	</div>
</template>

<script>



const ADD_URL = URL_APP + "api/v1/statistik_ketapang_laporan_form_analisisi_SPKG/";
const ADD_URL_DATE = URL_APP + "api/v1/statistik_ketapang_master_thn_bln/";
const FILE_LOAD = URL_APP + "uploads/";



export default {

    data() {
        return {
            data_load : false,
            form : {
                thn : 2019,

            },
            id :'',
            cek_load_data : true,
            file_old: "",
            file_path: FILE_LOAD,

            list_data: [],
            list_thn: []
        }
    },
    methods: {
        getView: function() {
            this.cek_load_data = true;
            fetch(ADD_URL + "K_1K", {
                method: "POST",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    thn: this.form.thn,
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    this.list_data = res_data;
                    this.cek_load_data = false;
                    console.log(res_data);
            });
        },

        getTahun : function(){
            fetch(ADD_URL_DATE + "thn", {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }            
            })
            .then(res => res.json())
            .then(res_data => {

                 this.list_thn = res_data;
                 this.getView();
            });
        },
        print: function() {



        },

       
    // ================== TAMBAHAN ====================
       


    // ================== TAMBAHAN ====================





        convert_tgl: function(dateString) {
            var date = new Date(dateString);
            var getBulan = date.getMonth() + 1; var bulan = '';
            if (getBulan == '1') {bulan = 'Jan'} 
            else if(getBulan == '2') {bulan = 'Feb'}
            else if(getBulan == '3') {bulan = 'Mar'}
            else if(getBulan == '4') {bulan = 'Apr'}
            else if(getBulan == '5') {bulan = 'Mei'}
            else if(getBulan == '6') {bulan = 'Jun'}
            else if(getBulan == '7') {bulan = 'Jul'}
            else if(getBulan == '8') {bulan = 'Agt'}
            else if(getBulan == '9') {bulan = 'Sep'}
            else if(getBulan == '10') {bulan = 'Okt'}
            else if(getBulan == '11') {bulan = 'Nov'}
            else if(getBulan == '12') {bulan = 'Des'}

            return date.getDate() + " " + bulan + " " + date.getFullYear();
            // return bulan+ " " + date.getDate() + ". " + date.getFullYear();
        }
        
    },
    mounted() {
        var get_profile = JSON.parse(localStorage.profile);
        // this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
        this.form.unit_kerja = get_profile.profile.unit_kerja;
        this.getTahun();
        // this.getView();



    },

}
</script>